import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  open(event) {
    event.preventDefault();
    if (typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal();
    }
  }

  close(event) {
    event?.preventDefault();
    if (typeof this.dialogTarget.close === "function" && this.dialogTarget.open) {
      this.dialogTarget.close();
    }
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.close();
    }
  }
}
